







import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';

import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'Sso', components: { }
})
export default class extends GiganautVue {
}
